import React from 'react';

var controller;
export default class navbar extends React.Component {

    constructor() {
        super()
        this.state = {
            toggleClass: '',
            activeMenuPoint: 'home'
        }
    }

    componentWillMount() {
        this.observers()
    }

    componentDidMount() {
        $('.overlay-nav a').on('click', function () {
            this.toggleMenu()
        }.bind(this))
        var ele = $('.navbar')
        controller = new ScrollMagic.Controller();
        new ScrollMagic.Scene({triggerElement: ele, offset: "100vh", duration: "70%"})
            .setTween($(ele), 1, {
                backgroundColor: "white",
                color: "black",
                fill: "black"
            }).addTo(controller);

        var ele = $('.navbar .logo, .navbar svg')
        controller = new ScrollMagic.Controller();
        new ScrollMagic.Scene({triggerElement: ele, offset: "100vh", duration: "70%"})
            .setTween($(ele), 1, {
                color: "black",
                fill: "black"
            }).addTo(controller);
    }


    observers() {
        $(document).on("menu:active", function (event, activeMenuPoint) {
            this.setActiveMenuPoint(activeMenuPoint)
        }.bind(this));
        $(document).on("menu:clear", function (event) {
            this.clear()
        }.bind(this));
    }

    setActiveMenuPoint(activeMenuPoint) {
        console.log(activeMenuPoint)
        if (activeMenuPoint) {
            this.setState({activeMenuPoint: activeMenuPoint});
        } else {
            this.setState({activeMenuPoint: 'home'});
        }
    }

    toggleMenu() {
        if (this.state.toggleClass) {
            this.setState({toggleClass: ''});
        } else {
            this.setState({toggleClass: 'active'});
        }
    }

    render() {
        return <section>
            <div className={"navbar " + this.state.toggleClass}>
                <div className="container-full">
                    <div className="row">
                        <div className="gr-4">
                            <ul>
                                <li>
                                    <a href="#/" className="logo">
                                        <img src="public/images/joelkernasenko_logo.svg" alt="" style={{width: "200px"}}/>
                                    </a>
                                </li>
                            </ul>

                        </div>
                        <div className="gr-8">
                            <ul className={"pull-right menu " + this.state.toggleClass}>
                                <li>
                                    <a onClick={this.toggleMenu.bind(this)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                             viewBox="0 0 24 24">
                                            <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"/>
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"overlay-nav " + this.state.toggleClass}>
                <div className="container">
                    <div className="row row-align-middle">
                        <ul>
                            <li>
                                <a href="#/">Overview</a>
                            </li>
                            <li>
                                <a href="#/categories/xbow">Xbow</a>
                            </li>
                            <li>
                                <a href="#/categories/boldideas">Bold Ideas</a>
                            </li>
                            <li>
                                <a href="#/categories/visualbranding">Visual Branding</a>
                            </li>

                            <li>
                                <a href="#/categories/storytelling">Storytelling</a>
                            </li>

                            <li>
                                <a href="#/categories/people">People</a>
                            </li>

                            <li>
                                <a href="#/categories/lookbook">Lookbook</a>
                            </li>
                            <li>
                                <a href="#/about">About</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    }

}


// WEBPACK FOOTER //
// ./src/scripts/components/navbar.jsx